import React, { useState } from "react";
import handleCSRF from "../../config/CSRF";
import { toast } from "react-toastify";
import axios from "axios";
import { apiKey } from "../../config/config";

// Minimal supplier quick-add: name + phone only, for use inline on forms
// (e.g. Add Expense) where a supplier might not exist yet. Everything else
// (VAT, email, address, description) can be filled in later from the
// dedicated Suppliers section under User section.
function QuickAddSupplierModal({ setShowModal, setSuppliers }) {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    user_id: user?.user.id,
    outlet_id: user?.user.outlet_id,
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const postData = () => {
      axios
        .post(`${apiKey}/api/rms/admin/suppliers`, formData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setSuppliers((prev) => [
            ...prev,
            {
              label: res.data.name,
              value: res.data.id,
            },
          ]);
          setShowModal(false);
        })
        .catch((err) => {
          toast.error(err.response?.data?.message || "Error", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        .finally(() => setLoading(false));
    };
    handleCSRF(postData);
  };

  return (
    <div
      className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none bg-black bg-opacity-50 backdrop-blur py-4 px-2"
      onClick={() => setShowModal(false)}
    >
      <div
        className="relative mx-auto my-auto max-w-md w-full"
        onClick={(e) => e.stopPropagation()}
      >
        <form
          onSubmit={handleSubmit}
          className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none overflow-y-auto"
        >
          <div className="flex items-start justify-center p-5 border-solid border-blueGray-200 rounded-t">
            <h1 className="text-md text-[#7B20C7]">Add Supplier</h1>
            <button
              type="button"
              className="ml-auto float-right text-2xl"
              onClick={() => setShowModal(false)}
            >
              <span className="text-[#7B20C7]"> × </span>
            </button>
          </div>

          <div className="px-6 pb-2 space-y-3">
            <label htmlFor="">
              <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-semibold">
                Supplier Name
              </span>
              <div className="mb-2 pt-0">
                <input
                  type="text"
                  placeholder="Supplier Name"
                  className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
            </label>

            <label htmlFor="">
              <span className="text-d-bg-text text-sm mb-2 relative font-semibold">
                Phone
              </span>
              <div className="mb-2 pt-0">
                <input
                  type="text"
                  placeholder="Phone"
                  className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
            </label>

            <p className="text-xs text-gray-500">
              Need VAT number, email, or address too? Add the rest later from
              User Section &gt; Suppliers.
            </p>
          </div>

          <div className="flex justify-end p-3">
            <button
              className="bg-[#7B20C7] text-white text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
              type="submit"
            >
              {loading && (
                <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                  <img
                    className="w-4 mx-auto"
                    src="/assets/gif/button_loader.gif"
                    alt=""
                  />
                </span>
              )}
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default QuickAddSupplierModal;
